import React, { useState,useEffect } from "react";

function CloseChat({buttons2, closeChat,setHideFooter,sendMessage,indexLength,arrayLength}){
    const [disbledBtn, setDisabledBtn] = useState(false)
    useEffect(()=>{
        console.log(arrayLength, "arrayLength 6")
        console.log(indexLength, "indexLength 7")
        // console.log(parseInt(arrayLength?.length-1)+"Arraylength  - " + indexLength+ "IndexLength")
        if(parseInt(arrayLength?.length-1) > indexLength){
            setDisabledBtn(true)
        }
    }, [arrayLength])
    return(
        <>
            {
                buttons2?.map((buttons, i) => (
                    buttons.type === "close_chat" ?
                        <button type="button" className={`btn-outline btn-inlines-outline ${disbledBtn ? "btn-disabled" : ""}`} disabled={disbledBtn ? true : false} onClick={(e) => { closeChat() ;setDisabledBtn(true)}} >{buttons.title}</button>
                    :
                        <button type="button" className={`btn-outline btn-inlines-outline ${disbledBtn ? "btn-disabled" : ""}`} disabled={disbledBtn ? true : false} onClick={(e) => { sendMessage(buttons); setHideFooter(false); setDisabledBtn(true) }} >{buttons.title}</button>
                ))
            }
        </>
    )
}
export default CloseChat